<template>
    <div class="download">
        <wechat-tips ref="wechat" />
        <wechat-tips-for-ios ref="wechatIos" />
        <popup-download-tips ref="download" />
    </div>
</template>

<script lang="ts">
import qs from 'qs'
import { Dialog } from 'vant'
import { Component } from 'vue-property-decorator'

import BaseComponent from '@/BaseComponent'
import { GAME_DETAIL } from '@/data/game'

import { inAndroid, inBaiduBox, inIOS, inQQ, inSafari, inWechat } from '../../data/runtime'
import { errorTips } from '../../utils/Decorators'
import PopupDownloadTips from './children/popup-download-tips.vue'
import WechatTips from './children/wechat-tips.vue'
import WechatTipsForIos from './children/wechat-tips-for-ios.vue'

/** 下载引导
 *
 * @author
 * @create 2021-12-09 (星期四)
 */
@Component({ name: 'download', components: { WechatTips, WechatTipsForIos, PopupDownloadTips } })
export default class extends BaseComponent {
    /* props, data, getter */
    get gameId(): string {
        return this.$store.app.gameId
    }

    get isOnlyH5(): boolean {
        return this.$store.app.isOnlyH5
    }

    get guideImgs(): string {
        return this.$store.app.guideImgs
    }

    get h5GameUrl(): string {
        return this.$store.app.h5GameUrl
    }

    get officialCpsChl(): boolean {
        return this.$store.app.officialCpsChl
    }

    /* life event: [mounted, beforeDestory] */
    /* methods */

    /** 下载游戏 */
    @errorTips()
    // eslint-disable-next-line complexity
    async download(gameId: string, channelId: string, logo: string, gameDetail: any, osType: number): Promise<void> {
        if (inIOS && this.officialCpsChl && this.$route.name == 'download' && [1, 3].includes(osType)) {
            await (this.$refs.wechatIos as WechatTipsForIos).open(gameDetail?.showName)
            return
        }
        const download: PopupDownloadTips = this.$refs.download as any
        const res = await this.$apis.common.getGameInstallGuide({ gameId, channelId })
        let { guideImgs, downloadUrl } = res.data

        if (inAndroid) guideImgs = null

        // ? 以下环境, 弹出微信提示
        // if (inWechat || (inQQ && inIOS) || inBaiduBox) {
        if (inWechat || inBaiduBox) {
            const { download, precheck } = this.$route.query
            // ? 对于未拼接下载地址的链接, 重定向拼接 (绕过浏览器校验规则)
            if (!download && precheck == '1') {
                let query: string

                if (location.href.indexOf('?') !== -1) {
                    query = '&'
                } else {
                    query = '?'
                }

                // add query
                query += qs.stringify({ download: downloadUrl, guideImgs }, { encodeValuesOnly: true, skipNulls: true })

                // > merge target url and redirect
                location.href = location.origin + location.pathname + query
            } else {
                await (this.$refs.wechat as WechatTips).open()
            }
        } else {
            // > H5 游戏判断
            if (osType === 4 && this.isOnlyH5 && this.h5GameUrl && !inAndroid) {
                if (inSafari) {
                    const imgs: Array<string> = [this.guideImgs]
                    download.open(imgs, this.$store.app.gameInfo?.gameDetail?.icon1)
                    return
                } else {
                    // > ios其他浏览器
                    await Dialog.alert({
                        message: '请在Safari浏览器中打开此链接',
                        showCancelButton: false,
                        confirmButtonText: '确认'
                    })
                    return
                }
            }

            if (inSafari) {
                await Dialog.alert({
                    message: '即将开始安装游戏',
                    showCancelButton: false,
                    confirmButtonText: '确认'
                })
            }

            // > 弹出引导
            if (!inAndroid && guideImgs) {
                const imgs: Array<string> = guideImgs.split('|')
                download.open(imgs, logo)
            }

            // > 通过 location.href 跳转下载
            location.href = decodeURIComponent(downloadUrl)
        }
    }

    /** 下载游戏 (根据连接) */
    @errorTips()
    async downloadByLink(link: string, guideImgs?: string): Promise<void> {
        const download: PopupDownloadTips = this.$refs.download as any

        // ? 以下环境, 弹出微信提示
        // if (inWechat || (inQQ && inIOS) || inBaiduBox) {
        if (inWechat || inBaiduBox) {
            await (this.$refs.wechat as WechatTips).open()
        } else {
            // > 通过 location.href 跳转下载
            if (inIOS && inSafari) {
                await Dialog.alert({
                    message: '即将开始安装游戏',
                    showCancelButton: false,
                    confirmButtonText: '确认'
                })
            }

            // > 弹出引导
            if (!inAndroid && guideImgs) {
                const imgs: Array<string> = guideImgs.split('|')
                // download.open(imgs, GAME_DETAIL.icon1)
            }

            location.href = decodeURIComponent(link)
        }
    }

    async downloadForOther(): Promise<void> {
        const download: PopupDownloadTips = this.$refs.download as any

        const detail = GAME_DETAIL.find((item: any) => item.gameId === this.gameId)
        let guideImgs = detail?.guideImgs ?? ''
        let downloadUrl = detail?.downloadUrl ?? ''
        if (inAndroid) guideImgs = 'null'

        // ? 以下环境, 弹出微信提示
        // if (inWechat || (inQQ && inIOS) || inBaiduBox) {
        if (inWechat || inBaiduBox) {
            const { download } = this.$route.query
            // ? 对于未拼接下载地址的链接, 重定向拼接 (绕过浏览器校验规则)
            if (!download) {
                let query: string

                if (location.href.indexOf('?') !== -1) {
                    query = '&'
                } else {
                    query = '?'
                }

                // add query
                query += qs.stringify({ download: downloadUrl, guideImgs }, { encodeValuesOnly: true, skipNulls: true })

                // > merge target url and redirect
                location.href = location.origin + location.pathname + query
            } else {
                await (this.$refs.wechat as WechatTips).open()
            }
        } else {
            // > 弹出引导
            if (inIOS && inSafari) {
                const imgs: Array<string> = [guideImgs]
                download.open(imgs, detail?.icon1 ?? '')
            } else {
                // > 通过 location.href 跳转下载
                location.href = decodeURIComponent(downloadUrl)
            }
        }
    }
}
</script>

<style lang="less" scoped></style>
